import React, { Component } from 'react';
import moment from 'moment';
import axios from './request';
import Kouponi from './Kouponi';

import './sass/style.scss'


// Load customs
// var Perf = require('react-addons-perf');

//GLOBAL TIME SETTINGS
const LIMIT_HOUR  = 7;
const NOW = moment().format('H');

let TODAY = moment().format('YYYY-MM-DD');
// let TODAY_LABEL = moment().format('DD/MM');
// let PREV_LABEL  = moment().subtract(1, 'days').format('DD/MM');
// let NEXT_LABEL  = moment().add(1, 'days').format('DD/MM');

// IF IS PAST 00:00 BUT LESS THAN END_HOUR, SET PREVIOUS DATE AS CURRENT
if( NOW < LIMIT_HOUR ) {// more than 00:00 less than END_HOUR
  TODAY = moment().subtract(1, 'days').format('YYYY-MM-DD');
  // TODAY_LABEL = moment().subtract(1, 'days').format('DD/MM');
  // PREV_LABEL  = moment().subtract(2, 'days').format('DD/MM');
  // NEXT_LABEL  = moment().format('DD/MM');
}

// RESPONSIVE BREAKPOINTS
// var RBP_SM = 300;
const RBP_MOBILE_PORTRAIT = 420; // DOWN NEEDS TO HIDE O/U
const RBP_MOBILE = 481; // DOWN NEEDS TO HIDE O/U
const RBP_SM_DESKTOP = 701; // DOWN NEEDS TO HIDE O/U AND UNIFY COMP_NAME
const RBP_TABLET = 877; // DOWN NEEDS TO HIDE O/U

// MAPPING i WITH label
// const labelMapper = {
//   '-1': 'Χθές (' + PREV_LABEL + ')',
//   '0': 'Σήμερα (' + TODAY_LABEL + ')',
//   '1': 'Αύριο (' + NEXT_LABEL + ')'
// }

class KouponiApp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedGames: [],
      dateControls: [],
      soundEnabled: false,
      selectedDate: TODAY,
      showFilter: 'SHOW_ALL',
      textlink: '',
      isLive: true,
      res: {
        isTablet: false,
        isSmDesktop: false,
        isMobile: false,
        isMobilePortrait: false,
      }
    };

    this.toggleSound = this.toggleSound.bind(this);
    this.handleDate = this.handleDate.bind(this);
    this.handleShowFilter = this.handleShowFilter.bind(this);

    this.searchSelectedId = this.searchSelectedId.bind(this);
    this.handleSelectGame = this.handleSelectGame.bind(this);
    this.updateResponsiveFlags = this.updateResponsiveFlags.bind(this);
    this.fetchAvailableDays = this.fetchAvailableDays.bind(this);
  }

  componentWillMount() {
    let selectedGames = typeof(Storage) !== "undefined" ? localStorage.getItem("selectedGames") : [];

    if( selectedGames !== null ){
      selectedGames = selectedGames.split(',');

      if( selectedGames.length ){
        selectedGames = selectedGames[0] === TODAY ? selectedGames : [];
      }

      this.setState({
        selectedGames: selectedGames
      });

    }
  }

  componentDidMount() {
    this.updateResponsiveFlags();
    this.fetchAvailableDays();
  }


  toggleSound() {
    this.setState({
      soundEnabled: !this.state.soundEnabled
    })
  }

  handleDate(event) {
    const date = event.currentTarget.dataset.date;

    this.setState({
      selectedDate: date,
      isLive: date === TODAY,
    });

  }

  setTextLink = (textlink) => {
    this.setState({
      textlink
    })
  }

  handleShowFilter(event) {
    const filter = event.currentTarget.dataset.filter;
    // FILTER DOC / USAGE LIST:
    // SHOW_ALL
    // SHOW_ONLY_SELECTED
    // SHOW_ONLY_LIVE
    // SHOW_ONLY_FINISHED
    // SHOW_EXCEPT_FINISHED

    // Add remove classes btn-icon btn-toggle btn-flashing
    this.refs.soundFilter.className = (filter === 'SHOW_ONLY_LIVE')
                                      ? 'btn-icon btn-toggle btn-flashing'
                                      : 'btn-icon btn-toggle';

    this.setState({
      showFilter: filter,
      soundEnabled: this.state.soundEnabled || filter === 'SHOW_ONLY_SELECTED'
    })
  }

  searchSelectedId(needle) {
    // expects datatype INT
    let i, len;

    for(i = 1, len = this.state.selectedGames.length; i < len; i=i+1){ //start from 1, 0 = date
      if( this.state.selectedGames[i] === needle ) return true;
    }
    // if( this.state.selectedGames.length ){
    //   if( this.state.selectedGames.findIndex(function(gameID){
    //     return gameID == needle;
    //   }) !== -1 ) return true;
    // }

    return false;
  }

  handleSelectGame(event) {

    var id = event.currentTarget.dataset.id,
        index = this.state.selectedGames.indexOf(id);

    // Clone array
    var v = this.state.selectedGames.slice(0);

    // DATE SPECIFIED ACTIONS
    if( ! v.length ) {
      // If is empty add first the date
      v.push(TODAY);
    }
    ( index !== -1 ) ? v.splice(index, 1) : v.push(id);

    this.setState({
      selectedGames: v
    });

    // Save to localStorage
    // eslint-disable-next-line no-unused-expressions
    typeof(Storage) !== "undefined" ? localStorage.setItem('selectedGames', v) : null;

  }

  updateResponsiveFlags() {
    var width = parseInt( this.refs.kouponi_container.offsetWidth, 10 );
    // Set Tablet Version
    this.setState({
      res: {
        isTablet: width < RBP_TABLET,
        isSmDesktop: width < RBP_SM_DESKTOP,
        isMobile: width < RBP_MOBILE,
        isMobilePortrait: width < RBP_MOBILE_PORTRAIT,
      }
    })
  }

  fetchAvailableDays() {
    const _this = this;

    axios.get('/v2/kouponi/days').then((res) => {
      _this.setState({
        dateControls: res.data
      });
    })
    .catch((error) => {
      // WBS.log('ERROR ON AVAILABLE DAYS', error);
      _this.timeout = setTimeout(() => {
        _this.fetchAvailableDays();
        _this.timeout = null;
      }, 20000);
    });
  }

  render() {
    const { dateControls } = this.state;
    let resClass = '';
    resClass += this.state.res.isMobilePortrait ? ' isMobilePortrait' : '';
    resClass += this.state.res.isMobile ? ' isMobile' : '';
    resClass += this.state.res.isSmDesktop ? ' isSmDesktop' : '';
    resClass += this.state.res.isTablet ? ' isTablet' : '';

    return (
      <div ref="kouponi_container" className={resClass}>
        {this.state.isLive && <div className="r-kouponi-filters">

          <div className="filter show-filter">
            <span className="label">Φίλτρο προβολής</span>
            <div className="btn-group">
              <button className={this.state.showFilter === 'SHOW_ALL' ? 'filter-button active' : 'filter-button'} onClick={this.handleShowFilter} data-filter="SHOW_ALL">Όλα</button>
              <button className={this.state.showFilter === 'SHOW_ONLY_SELECTED' ? 'filter-button active' : ''} onClick={this.handleShowFilter} data-filter="SHOW_ONLY_SELECTED">
                <i className="label-icon fa fa-star"></i>
                { !this.state.res.isMobile ? 'Τα παιχνίδια μου' : '' }
                {this.state.selectedGames.length-1 > 0 ? <span className="bubble">{this.state.selectedGames.length-1}</span> : null}
              </button>
              <button className={this.state.showFilter === 'SHOW_ONLY_LIVE' ? 'filter-button active' : 'filter-button'} onClick={this.handleShowFilter} data-filter="SHOW_ONLY_LIVE">{ !this.state.res.isMobile ? 'Σε εξέλιξη' : 'Live'}</button>
              <button className={this.state.showFilter === 'SHOW_ONLY_FINISHED' ? 'filter-button active' : 'filter-button'} onClick={this.handleShowFilter} data-filter="SHOW_ONLY_FINISHED">Τελικά αποτελέσματα</button>
            </div>
          </div>

          <div className="filter sound-filter">
            <button className="btn-icon btn-toggle" ref="soundFilter" onClick={this.toggleSound}>
              {this.state.soundEnabled
                ? <i className="fa fa-volume-up active"></i>
                : <span className="fa fa-stack">
                  <i className="fa fa-volume-off fa-stack-1x"></i>
                    <i className="fa fa-ban fa-stack-2x"></i>
                  </span>}
            </button>
          </div>

        </div>}

        <Kouponi
          isExternal={this.props.isExternal}
          selectedDate={this.state.selectedDate ? this.state.selectedDate : TODAY}
          onSelectGame={this.handleSelectGame}
          searchSelectedId={this.searchSelectedId}
          isLive={this.state.isLive}
          soundEnabled={this.state.soundEnabled}
          res={this.state.res}
          dateControls={dateControls}
          handleDate={this.handleDate}
          showFilter={this.state.showFilter}
          clientId={this.props.clientId}
          setTextLink={this.setTextLink}
          productId={this.props.productId}
        />
        <div>
          {this.state.textlink && <div className="kouponi-app-text-link" dangerouslySetInnerHTML={{__html: this.state.textlink}}></div>}
        </div>
      </div>
    )
  }

};

export default KouponiApp



// WEBPACK FOOTER //
// ./src/App.js